import { logoutApi } from "services/authServices";

const authActions = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SET_USER: "SET_USER",

  login: data => {
    localStorage.setItem("isLogin", true);
    localStorage.setItem("accessToken", data.token);
    localStorage.setItem("isUser", data.is_user);
    localStorage.setItem("isSuperAdmin", data.is_superadmin);

    return {
      type: authActions.LOGIN,
      isLogin: true,
      accessToken: data.token,
      isUser: data.is_user,
      isSuperAdmin: data.data
    };
  },
  setUser: data => {
    return {
      type: authActions.SET_USER,
      user: data
    };
  },
  check: data => {
    localStorage.setItem("isLogin", true);
    localStorage.setItem("accessToken", data.token);
    localStorage.setItem("isUser", data.is_user);
    localStorage.setItem("isSuperAdmin", data.is_superadmin);
    return {
      type: authActions.LOGIN,
      isLogin: true,
      accessToken: data.token,
      isUser: data.is_user,
      user: data,
      isSuperAdmin: data.is_superadmin
    };
  },
  logout: token => {
    if (token !== null || token !== "null") {
      logoutApi(token).then(data => {});
    }
    localStorage.setItem("isLogin", false);
    localStorage.setItem("accessToken", "");
    localStorage.setItem("isUser", null);
    localStorage.setItem("isSuperAdmin", null);

    document.cookie = document.cookie = `token= ;SameSite=strict;max-age=0}`;
    return {
      type: authActions.LOGOUT,
      isLogin: false,
      accessToken: null,
      isUser: null,
      isSuperAdmin: null
    };
  }
};

export default authActions;
